import { Injectable } from "@angular/core";
import { LoadingService } from '@shared/src/public-api';

@Injectable({
    providedIn: 'root'
  })
export class MobileLoadingService extends LoadingService {

}